import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";

interface FieldInfoTooltipProps {
    content: string;
    ariaLabel?: string;
}

const FieldInfoTooltip: React.FC<FieldInfoTooltipProps> = ({ content, ariaLabel }) => (
    <TooltipProvider delayDuration={100}>
        <Tooltip>
            <TooltipTrigger asChild>
                <button
                    type="button"
                    className="inline-flex shrink-0 rounded-full p-0.5 text-primary/70 transition-colors hover:bg-primary/10 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    aria-label={ariaLabel ?? content}
                    onClick={(e) => e.preventDefault()}
                >
                    <Info className="h-3.5 w-3.5" />
                </button>
            </TooltipTrigger>
            <TooltipContent
                side="top"
                className="max-w-[280px] px-3 py-2 text-xs font-normal normal-case leading-relaxed"
            >
                {content}
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
);

export function fieldLabelWithTooltip(label: React.ReactNode, tooltip: string) {
    return (
        <span className="inline-flex items-center gap-1.5">
            {label}
            <FieldInfoTooltip content={tooltip} ariaLabel={tooltip} />
        </span>
    );
}

export default FieldInfoTooltip;
